import { Injectable } from '@angular/core';
import {ApiService} from '../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ReportingService {

    constructor(private api: ApiService) {

    }

    getVnaCampaigns(): Observable<any>{
        return this.api.get('vna-campaign');
    }

    getCallsReport(criteria: Object): Observable<any> {
        return this.api.get('vna-campaign/calls', criteria);
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/reporting/services/reporting.service.ts